module.exports = __webpack_public_path__ + "img/pythonLogo.dc199ecc.png";